import {
  GETKYCACCOUNTTYPELIST_SUCCESS,
  GETKYCACCOUNTTYPELIST_FAILED,
  RESET_GETKYCACCOUNTTYPELIST,
  LOADING_GETKYCACCOUNTTYPELIST,
  NETWORK_ERROR_GETKYCACCOUNTTYPELIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETKYCACCOUNTTYPELIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETKYCACCOUNTTYPELIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETKYCACCOUNTTYPELIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETKYCACCOUNTTYPELIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETKYCACCOUNTTYPELIST:
      return (state = initialState);
    default:
      return state;
  }
};
